<div mat-dialog-title class="rpt-titlebar">
  <span class="rpt-title">{{ '@issueReportTitle' | translate }}</span>
  <button mat-icon-button class="rpt-close" (click)="close()" [attr.aria-label]="'@cancel' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <app-report-issue-form #form
                         [assetId]="data.assetId"
                         [assetName]="data.assetName"
                         [assetVin]="data.assetVin"
                         [openIssues]="data.openIssues"
                         [showActions]="false"
                         (reported)="close($event)"
                         (cancelled)="close()"></app-report-issue-form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [disabled]="form.submitting" (click)="close()">{{ '@cancel' | translate }}</button>
  <button mat-flat-button color="primary" data-e2e="report-issue-submit"
          [disabled]="form.submitting" (click)="form.submit()">
    {{ form.submitLabelKey | translate }}
  </button>
</mat-dialog-actions>
